import AppStoreContext from "@myinnsworth/contexts/AppStoreContext";
import { AuthenticationState } from "@myinnsworth/contexts/AuthenticationContext";
import { useAuthentication } from "@myinnsworth/hooks/authenticationHook";
import { casesHttpService, listHttpService } from "@myinnsworth/httpServices";
import { ICountry } from "@myinnsworth/models/address/ICountry";
import { IApplicant } from "@myinnsworth/models/applicants/IApplicant";
import ICase from "@myinnsworth/models/case/ICase";
import { ReactNode, useCallback, useEffect, useRef, useState } from "react";

interface IAppStoreProviderProps {
    children?: ReactNode;
}

const AppStoreProvider = (props: IAppStoreProviderProps) => {
    const auth = useAuthentication();
    const [cases, setCases] = useState<Array<ICase>>([]);
    const [countries, setCountries] = useState<Array<ICountry>>([]);
    const [currentApplicant, setCurrentApplicant] = useState<IApplicant>();
    const fetchingCases = useRef<boolean>(false);
    const fetchingCountries = useRef<boolean>(false);

    const fetchCases = useCallback(async () => {
        if(cases.length === 0 && !fetchingCases.current) {
            try {
                fetchingCases.current = true;
                const results = await casesHttpService.search({});
                setCases(results.results);
            } catch {
                setCases([]);
            } finally {
                fetchingCases.current = false;
            }
        }
    }, [cases.length]);

    const fetchCountries = useCallback(async () => {
        if(countries.length === 0 && !fetchingCountries.current) {
            try {
                fetchingCountries.current = true;
                const results = await listHttpService.fetchCountries();
                setCountries(results);
            } catch {
                setCountries([]);
            } finally {
                fetchingCountries.current = false;
            }
        }
    }, [countries.length]);

    useEffect(() => {
        if(auth.state === AuthenticationState.SignedIn) {
            fetchCases();
            fetchCountries();
        } else {
            setCases([]);
            setCountries([]);
        }
    }, [auth.state, fetchCases, fetchCountries]);
    
    return (
        <AppStoreContext.Provider value={{cases, countries, currentApplicant, setCurrentApplicant}}>
            {props.children}
        </AppStoreContext.Provider>
    );
}

export default AppStoreProvider;